import cx from 'classnames';
import { PropsWithChildren } from 'react';

import style from './ModalBody.module.css';

export type ModalBodyProps = PropsWithChildren<{
    dark?: boolean;
    hasBottomScrollIndicator?: boolean;
    className?: string;
}>;

export function ModalBody({ dark, hasBottomScrollIndicator, className, children }: ModalBodyProps) {
    return (
        <div
            className={cx(style.wrapper, className, {
                [style.dark]: dark,
                [style.hasBottomScrollIndicator]: hasBottomScrollIndicator,
            })}
        >
            <div
                className={cx(style.body, {
                    [style.dark]: dark,
                })}
            >
                {children}
            </div>
        </div>
    );
}
